<p-toast position="top-center" key="global"></p-toast>
<app-language-selector></app-language-selector>
<router-outlet></router-outlet>